<igx-grid #gridExpInsumos [primaryKey]="'IdCatalogo'" [data]="dataExpInsumo" [width]="'100%'" [height]="'100%'" [locale]="localGrid"
          [allowFiltering]="true" [filterMode]="'excelStyleFilter'" [rowEditable]="false" [rowSelection]="rowSelectionSingle"
          [sortingOptions]="sortingOptions" [moving]="true">
  <igx-grid-toolbar>
    <igx-grid-toolbar-title>
      <app-filtro-general #filtroGeneral descripcionLabel="{{ 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL' | translate}}" [mostrarChkInicio]="true" (enterPalabra)="filterInput($event)" (limpiarPalabras)="clearInput()" />
    </igx-grid-toolbar-title>
    <igx-grid-toolbar-actions>
      <igx-grid-toolbar-hiding />
      <igx-grid-toolbar-pinning />
      <app-mas-opciones-grid #masOpcionesG [arrayDatosAVer]="[6]" (opcionSeleccionada)="onSelectionDropDown($event)" />
    </igx-grid-toolbar-actions>
  </igx-grid-toolbar>
  <ng-template igxSortHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortAscendingHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortDescendingHeaderIcon>
    <igx-icon>south</igx-icon>
  </ng-template>
  <ng-template igxExcelStyleHeaderIcon>
    <igx-icon>filter_alt</igx-icon>
  </ng-template>
  <igx-column field="Codigo" header="{{'GRIDS.EXP_INSUMO.COL_CODIGO' | translate}}" [dataType]="'string'" width="160px" [sortable]="true" [resizable]="true"  />
  <igx-column field="Tipo" header="{{'GRIDS.EXP_INSUMO.COL_TIPO_INSUMO' | translate}}" [dataType]="'number'" width="90px" [sortable]="true" [resizable]="true"  />
  <igx-column field="DescripcionLarga" header="{{'GRIDS.EXP_INSUMO.COL_DESCRIPCION_LARGA' | translate}}" [dataType]="'string'" width="360px"  [sortable]="true"  [resizable]="true" [hasSummary]="true" [summaries]="'filasSummary' | summaryPipeNeo" />
  <igx-column field="Descripcion" header="{{'GRIDS.EXP_INSUMO.COL_DESCRIPCION' | translate}}" [dataType]="'string'" width="260px"  [sortable]="true"  [resizable]="true" [hidden]="true" />
  <igx-column field="Familia" header="{{'GRIDS.EXP_INSUMO.COL_FAMILIA' | translate}}" [dataType]="'string'" width="150px" [sortable]="true" [resizable]="true"  />
  <igx-column field="Unidad" header="{{'GRIDS.EXP_INSUMO.COL_UNIDAD' | translate}}" [dataType]="'string'" width="100px" [sortable]="true" [resizable]="true"  />
  @if (todasLasColumnas) {
    <igx-column field="EsPorcentaje" header="%" [dataType]="'percent'" width="90px" [sortable]="true" [resizable]="true"  [pipeArgs]="formatPorcentaje2Dec" [hasSummary]="true" [summaries]="'porcentajeSummary' | summaryPipeNeo" />
  }
</igx-grid>
